const initalState = {
  dealerList: [],
  shortDealerList: [],
  dealerSort: {
    prop: '',
    isDesc: false
  },
  dealerSearch: {
    searchTerm: '',
    searchedDealerList: []
  },
  jobsByDealer: {}
}
export const dealersReducer = (state = initalState, action) => {
  switch(action.type) {
    case 'FETCH_DEALERS':
      return {
        ...state,
        dealerList: [...action.payload],
        shortDealerList: action.payload.filter(v => v.status === 'active').map(v => v.name)
      }
    case 'ADD_DEALER_SORT':
      return {
        ...state,
        dealerSort: action.payload
      }
    case 'CREATE_NEW_DEALER':
      const dealerListWithNewOne = [...state.dealerList, action.payload];
      const shortDealerListWithNewOne = dealerListWithNewOne.filter(v => v.status === 'active').map(v => v.name);
      return {
        ...state,
        dealerList: dealerListWithNewOne,
        shortDealerList: shortDealerListWithNewOne,
        dealerSearch: {
          searchTerm: '',
          searchedDealerList: []
        }
      }
    case 'UPDATE_DEALER':
      const newDealerList = state.dealerList.map(dealer => dealer.UUID === action.payload.id ? {...dealer, ...action.payload.dealer} : dealer);
      const newShortDealerList = newDealerList.filter(v => v.status === 'active').map(v => v.name);
      return {
        ...state,
        dealerList: newDealerList,
        shortDealerList: newShortDealerList
      }
    case 'ADD_DEALER_SEARCH':
      return {
        ...state,
        dealerSearch: {
          searchTerm: action.payload.searchTerm,
          searchedDealerList: action.payload.searchedDealerList
        }
      }
    case 'CLEAR_DEALER_SEARCH':
      return {
        ...state,
        dealerSearch: {
          searchTerm: '',
          searchedDealerList: []
        }
      }
    case 'DELETE_DEALER':
      const dealerListWithoutDeleted = state.dealerList.map(dealer => dealer.UUID === action.payload.UUID ? {...dealer, status: 'deleted'} : dealer);
      const shortDealerListWithoutDeleted = dealerListWithoutDeleted.filter(v => v.status === 'active').map(v => v.name);

      return {
        ...state,
        dealerSearch: {
          ...state.dealerSearch,
          searchedDealerList: state.dealerSearch.searchedDealerList.map(dealer => dealer.UUID === action.payload.UUID ? {...dealer, status: 'deleted'} : dealer)
        },
        dealerList: dealerListWithoutDeleted,
        shortDealerList: shortDealerListWithoutDeleted
      }
    case 'FETCH_JOBS_BY_DEALER':
      return {
        ...state,
        jobsByDealer: {
          ...state.jobsByDealer,
          [action.payload.dealerId]: action.payload.jobs
        }
      }
    case 'UPDATE_JOB':
      return {
        ...state,
        jobsByDealer: {}
      }
    default:
      return state;
  }
}
